/** general link relations */
export enum LinkRelation {
  follow = 'follow',
  nofollow = 'nofollow',
  sponsored = 'sponsored'
}

/** general link targets */
export enum LinkTarget {
  blank = '_blank',
  parent = '_parent',
  self = '_self',
  top = '_top'
}
